import { useEffect, useState } from 'react'

import { getIsDarkMode } from '~/utils/get-is-dark-mode'

export const useIsDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(getIsDarkMode)

  useEffect(() => {
    const syncDarkMode = () => setIsDarkMode(getIsDarkMode())

    const colorSchemeMediaQueryList = window.matchMedia('(prefers-color-scheme: dark)')
    colorSchemeMediaQueryList.addEventListener('change', syncDarkMode)

    const darkClassObserver = new MutationObserver(syncDarkMode)
    darkClassObserver.observe(document.documentElement, { attributeFilter: ['class'], attributes: true })

    return () => {
      colorSchemeMediaQueryList.removeEventListener('change', syncDarkMode)
      darkClassObserver.disconnect()
    }
  }, [])

  return isDarkMode
}
